import { render, staticRenderFns } from "./LoginInfo.vue?vue&type=template&id=23ee83d4&scoped=true"
import script from "./LoginInfo.vue?vue&type=script&lang=js"
export * from "./LoginInfo.vue?vue&type=script&lang=js"
import style0 from "./LoginInfo.vue?vue&type=style&index=0&id=23ee83d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ee83d4",
  null
  
)

export default component.exports